import { createFileRoute } from "@tanstack/react-router";

import { parseMarketSearch } from "@/features/administration";
import { CoursePricesPage } from "@/features/administration/pages";
import { strictSearch } from "@/shared/lib/search";

/** What a later visit of a course and a specialist-made visit cost, a market at a time. */
export const Route = createFileRoute("/_app/settings/course-prices")({
  validateSearch: strictSearch(parseMarketSearch),
  component: CoursePrices,
});

function CoursePrices() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CoursePricesPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
    />
  );
}
